import { useCallback, useMemo } from 'react';
import { useAtom } from 'jotai';
import { Button, ButtonGroup, Stack } from '@mui/material';
import { VisibilityBoxMode } from '@abyss/3d-viewer';
import * as globalState from '@/state';
import { useZoneVisibilityBox } from '../hooks';

export const VisibilityBoxPanel = () => {
  const [currentVisibilityBox, setCurrentVisibilityBox] = useAtom(
    globalState.currentVisibilityBox
  );

  const isEnabled = useMemo(() => {
    return currentVisibilityBox.mode !== VisibilityBoxMode.Disabled;
  }, [currentVisibilityBox.mode]);

  const isEditMode = useMemo(() => {
    return currentVisibilityBox.mode === VisibilityBoxMode.Adjusting;
  }, [currentVisibilityBox.mode]);

  const setVisibilityBoxMode = useCallback(
    (newMode: VisibilityBoxMode) => {
      setCurrentVisibilityBox((current) =>
        current.mode === newMode
          ? current
          : {
              ...current,
              mode: newMode,
            }
      );
    },
    [setCurrentVisibilityBox]
  );

  const { setDefaultZoneVisibilityBox } = useZoneVisibilityBox();

  const resetVisibilityBox = useCallback(() => {
    setVisibilityBoxMode(VisibilityBoxMode.Enabled);
    setDefaultZoneVisibilityBox();
  }, [setDefaultZoneVisibilityBox, setVisibilityBoxMode]);

  return (
    <Stack>
      <ButtonGroup>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => setVisibilityBoxMode(VisibilityBoxMode.Adjusting)}
          disabled={!isEnabled || isEditMode}
          sx={{ width: 'auto' }}
        >
          Adjust Visibility Box
        </Button>
        {isEditMode && (
          <Button
            variant="contained"
            color="secondary"
            onClick={() => resetVisibilityBox()}
            disabled={!isEnabled || !isEditMode}
          >
            Reset
          </Button>
        )}
        {isEditMode && (
          <Button
            variant="contained"
            color="secondary"
            onClick={() => setVisibilityBoxMode(VisibilityBoxMode.Enabled)}
            disabled={!isEnabled || !isEditMode}
          >
            Done
          </Button>
        )}
      </ButtonGroup>
    </Stack>
  );
};
